/**
 * IMPORTANT! This must match the server-side implementation to prevent persisted query mismatches.
 *
 *  Create a SHA256 hash of a string using the provided API.
 *
 * @link https://github.com/dotansimha/graphql-yoga/blob/f5a2ae987ce3db45118c8ca062d46a96d669dc3e/packages/plugins/apq/src/index.ts#L3-L19
 */
export async function createSha256HashForPersistedQuery(
  str: string,
  api: {
    crypto: Crypto;
    TextEncoder: (typeof globalThis)['TextEncoder'];
  } = globalThis
) {
  const { crypto, TextEncoder } = api;
  const textEncoder = new TextEncoder();
  const utf8 = textEncoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  let hashHex = '';
  for (const bytes of new Uint8Array(hashBuffer)) {
    hashHex += bytes.toString(16).padStart(2, '0');
  }

  return hashHex;
}
